import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesCustomFieldsAssociateRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-custom-fields-associate',
	path: '/secure/admin/AssociateFieldToScreens!default.jspa',
};
